import React, { createContext, useContext, useMemo, useRef, useState, useEffect } from 'react';
import get from 'get-value';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var b = "function" === typeof Symbol && Symbol["for"],
    c = b ? Symbol["for"]("react.element") : 60103,
    d = b ? Symbol["for"]("react.portal") : 60106,
    e = b ? Symbol["for"]("react.fragment") : 60107,
    f = b ? Symbol["for"]("react.strict_mode") : 60108,
    g = b ? Symbol["for"]("react.profiler") : 60114,
    h = b ? Symbol["for"]("react.provider") : 60109,
    k = b ? Symbol["for"]("react.context") : 60110,
    l = b ? Symbol["for"]("react.async_mode") : 60111,
    m = b ? Symbol["for"]("react.concurrent_mode") : 60111,
    n = b ? Symbol["for"]("react.forward_ref") : 60112,
    p = b ? Symbol["for"]("react.suspense") : 60113,
    q = b ? Symbol["for"]("react.suspense_list") : 60120,
    r = b ? Symbol["for"]("react.memo") : 60115,
    t = b ? Symbol["for"]("react.lazy") : 60116,
    v = b ? Symbol["for"]("react.block") : 60121,
    w = b ? Symbol["for"]("react.fundamental") : 60117,
    x = b ? Symbol["for"]("react.responder") : 60118,
    y = b ? Symbol["for"]("react.scope") : 60119;

function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;

    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;

              default:
                return u;
            }

        }

      case d:
        return u;
    }
  }
}

function A(a) {
  return z(a) === m;
}

var AsyncMode = l;
var ConcurrentMode = m;
var ContextConsumer = k;
var ContextProvider = h;
var Element = c;
var ForwardRef = n;
var Fragment = e;
var Lazy = t;
var Memo = r;
var Portal = d;
var Profiler = g;
var StrictMode = f;
var Suspense = p;

var isAsyncMode = function isAsyncMode(a) {
  return A(a) || z(a) === l;
};

var isConcurrentMode = A;

var isContextConsumer = function isContextConsumer(a) {
  return z(a) === k;
};

var isContextProvider = function isContextProvider(a) {
  return z(a) === h;
};

var isElement = function isElement(a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};

var isForwardRef = function isForwardRef(a) {
  return z(a) === n;
};

var isFragment = function isFragment(a) {
  return z(a) === e;
};

var isLazy = function isLazy(a) {
  return z(a) === t;
};

var isMemo = function isMemo(a) {
  return z(a) === r;
};

var isPortal = function isPortal(a) {
  return z(a) === d;
};

var isProfiler = function isProfiler(a) {
  return z(a) === g;
};

var isStrictMode = function isStrictMode(a) {
  return z(a) === f;
};

var isSuspense = function isSuspense(a) {
  return z(a) === p;
};

var isValidElementType = function isValidElementType(a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};

var typeOf = z;
var reactIs_production_min = {
  AsyncMode: AsyncMode,
  ConcurrentMode: ConcurrentMode,
  ContextConsumer: ContextConsumer,
  ContextProvider: ContextProvider,
  Element: Element,
  ForwardRef: ForwardRef,
  Fragment: Fragment,
  Lazy: Lazy,
  Memo: Memo,
  Portal: Portal,
  Profiler: Profiler,
  StrictMode: StrictMode,
  Suspense: Suspense,
  isAsyncMode: isAsyncMode,
  isConcurrentMode: isConcurrentMode,
  isContextConsumer: isContextConsumer,
  isContextProvider: isContextProvider,
  isElement: isElement,
  isForwardRef: isForwardRef,
  isFragment: isFragment,
  isLazy: isLazy,
  isMemo: isMemo,
  isPortal: isPortal,
  isProfiler: isProfiler,
  isStrictMode: isStrictMode,
  isSuspense: isSuspense,
  isValidElementType: isValidElementType,
  typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {

  if (process.env.NODE_ENV !== "production") {
    (function () {

      var hasSymbol = typeof Symbol === 'function' && Symbol["for"];
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol["for"]('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol["for"]('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol["for"]('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol["for"]('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol["for"]('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol["for"]('react.context') : 0xeace;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol["for"]('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol["for"]('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol["for"]('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol["for"]('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol["for"]('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol["for"]('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol["for"]('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol["for"]('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol["for"]('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol["for"]('react.scope') : 0xead7;

      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }

      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;

              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }

              }

            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return undefined;
      }

      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }

      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }

      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }

      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }

      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }

      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }

      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }

      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }

      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }

      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }

      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }

      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }

      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }

      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});

var reactIs = createCommonjsModule(function (module) {

  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min;
  } else {
    module.exports = reactIs_development;
  }
});

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }

    var test1 = new String('abc');
    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    }

    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    }

    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    return false;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var printWarning = function printWarning() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      throw new Error(message);
    } catch (x) {}
  };
}

function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;

        try {
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }

        if (error && !(error instanceof Error)) {
          printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }

        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}

checkPropTypes.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;

var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning$1 = function printWarning() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function printWarning(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  var ANONYMOUS = '<<anonymous>>';
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };

  function is(x, y) {
    if (x === y) {
      return x !== 0 || 1 / x === 1 / y;
    } else {
      return x !== x && y !== y;
    }
  }

  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }

  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }

    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          var cacheKey = componentName + ':' + propName;

          if (!manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3) {
            printWarning$1('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }

      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }

          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }

        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== expectedType) {
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }

      var propValue = props[propName];

      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }

      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);

        if (error instanceof Error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }

      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);

        if (type === 'symbol') {
          return String(value);
        }

        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }

      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }

      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

          if (error instanceof Error) {
            return error;
          }
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];

      if (typeof checker !== 'function') {
        printWarning$1('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];

        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }

      for (var key in shapeTypes) {
        var checker = shapeTypes[key];

        if (!checker) {
          continue;
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }

      var allKeys = objectAssign({}, props[propName], shapeTypes);

      for (var key in allKeys) {
        var checker = shapeTypes[key];

        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;

      case 'boolean':
        return !propValue;

      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }

        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);

        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;

          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            while (!(step = iterator.next()).done) {
              var entry = step.value;

              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;

      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    if (propType === 'symbol') {
      return true;
    }

    if (!propValue) {
      return false;
    }

    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  function getPropType(propValue) {
    var propType = typeof propValue;

    if (Array.isArray(propValue)) {
      return 'array';
    }

    if (propValue instanceof RegExp) {
      return 'object';
    }

    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }

    return propType;
  }

  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }

    var propType = getPropType(propValue);

    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }

    return propType;
  }

  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);

    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;

      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;

      default:
        return type;
    }
  }

  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }

    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function factoryWithThrowingShims() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      return;
    }

    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;

  function getShim() {
    return shim;
  }
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV !== 'production') {
    var ReactIs = reactIs;
    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
  } else {
    module.exports = factoryWithThrowingShims();
  }
});

var BasicFieldPropTypes = {
  label: propTypes.string,
  disabled: propTypes.bool,
  value: propTypes.any,
  helperText: propTypes.string,
  onChange: propTypes.func,
  name: propTypes.string
};

var DigKeyPropType = propTypes.oneOfType([propTypes.array, propTypes.string]);
var OptionsFieldPropTypes = _extends({}, BasicFieldPropTypes, {
  options: propTypes.array,
  valueKey: DigKeyPropType,
  labelKey: DigKeyPropType
});
var BaseSelectPropTypes = {
  placeholder: propTypes.string,
  options: propTypes.array.isRequired
};

var MultiSelectFieldPropTypes = _extends({}, OptionsFieldPropTypes, {
  output: propTypes.string
});

var BaseBoolPropTypes = {
  checked: propTypes.bool
};

var isListField = function isListField(field) {
  return field.of !== undefined;
};
var ListFieldPropTypes = {
  of: propTypes.any,
  deletable: propTypes.bool,
  editable: propTypes.bool,
  creatable: propTypes.bool,
  defaultNewVal: propTypes.any,
  createLabel: propTypes.string,
  createPlaceholder: propTypes.string,
  inlineDelete: propTypes.bool
};

var isObjectField = function isObjectField(field) {
  return field.type === 'object';
};
var ObjectFieldPropTypes = _extends({}, BasicFieldPropTypes, {
  fields: propTypes.any
});

var FieldPropTypes = _extends({}, BasicFieldPropTypes);

var isFormValue = function isFormValue(value) {
  return !Array.isArray(value) && typeof value === 'object';
};

var FieldDecoration = function FieldDecoration(_ref) {
  var _ref$noLabel = _ref.noLabel,
      noLabel = _ref$noLabel === void 0 ? false : _ref$noLabel,
      helperText = _ref.helperText,
      label = _ref.label,
      required = _ref.required,
      errors = _ref.errors,
      children = _ref.children;

  var _useBaseComponents = useBaseComponents(),
      HelperText = _useBaseComponents.HelperText,
      LabelText = _useBaseComponents.LabelText,
      Error = _useBaseComponents.Error,
      Box = _useBaseComponents.Box;

  var content = React.createElement(React.Fragment, null, label !== undefined ? React.createElement(LabelText, null, label, (required !== null && required !== void 0 ? required : false) ? React.createElement(Error, null, " *") : null) : null, children, helperText !== undefined || errors !== undefined && errors !== null ? React.createElement(HelperText, null, helperText, errors !== undefined && errors !== null ? React.createElement(Box, null, React.createElement(Error, null, errors.join())) : null) : null);
  return (noLabel !== null && noLabel !== void 0 ? noLabel : false) ? React.createElement(Box, null, content) : React.createElement("label", null, content);
};

var BaseInput = function BaseInput(props) {
  return React.createElement("input", Object.assign({
    className: 'form-control'
  }, props));
};
BaseInput.defaultProps = {
  value: ''
};
var BaseSelect = function BaseSelect(_ref) {
  var _options$findIndex;

  var _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      options = _ref.options,
      onChange = _ref.onChange,
      props = _objectWithoutPropertiesLoose(_ref, ["value", "options", "onChange"]);

  var handleChange = function handleChange(_ref2) {
    var _options$Number$parse;

    var value = _ref2.target.value;
    onChange === null || onChange === void 0 ? void 0 : onChange((_options$Number$parse = options[Number.parseInt(value)]) === null || _options$Number$parse === void 0 ? void 0 : _options$Number$parse.value);
  };

  return React.createElement("select", Object.assign({
    className: 'form-control',
    onChange: handleChange,
    value: (_options$findIndex = options.findIndex(function (_ref3) {
      var v = _ref3.value;
      return value === v;
    })) !== null && _options$findIndex !== void 0 ? _options$findIndex : ''
  }, props), React.createElement("option", {
    value: ""
  }, props.placeholder), options.map(function (_ref4, index) {
    var label = _ref4.label;
    return React.createElement("option", {
      key: label,
      value: index
    }, label);
  }));
};
var BaseCheckbox = function BaseCheckbox(props) {
  return React.createElement("input", Object.assign({
    className: 'form-check-input',
    type: 'checkbox'
  }, props));
};
var HelperText = function HelperText(props) {
  return React.createElement("small", Object.assign({
    className: 'box form-text text-muted'
  }, props));
};
var LabelText = function LabelText(props) {
  return React.createElement("span", Object.assign({
    className: 'box form-label'
  }, props));
};
var Label = function Label(props) {
  return React.createElement("label", Object.assign({}, props));
};
var FieldWrapper = function FieldWrapper(props) {
  return React.createElement("div", Object.assign({
    className: 'reforml-form-group'
  }, props));
};
var ListInputDecoration = function ListInputDecoration(_ref5) {
  var required = _ref5.required,
      errors = _ref5.errors,
      label = _ref5.label,
      helperText = _ref5.helperText,
      children = _ref5.children,
      props = _objectWithoutPropertiesLoose(_ref5, ["required", "errors", "label", "helperText", "children"]);

  return React.createElement("div", null, React.createElement("div", Object.assign({
    className: 'list-input-decoration'
  }, props), label !== undefined ? React.createElement("div", {
    className: 'list-input-label'
  }, React.createElement("div", null, label, (required !== null && required !== void 0 ? required : false) ? React.createElement(Error$1, null, " *") : null)) : null, React.createElement("div", null, children)), helperText !== undefined || errors !== undefined && errors !== null ? React.createElement(HelperText, null, helperText, errors !== undefined && errors !== null ? React.createElement(Box, null, React.createElement(Error$1, null, errors.join())) : null) : null);
};
var ObjectInputDecoration = function ObjectInputDecoration(_ref6) {
  var required = _ref6.required,
      errors = _ref6.errors,
      label = _ref6.label,
      helperText = _ref6.helperText,
      children = _ref6.children,
      props = _objectWithoutPropertiesLoose(_ref6, ["required", "errors", "label", "helperText", "children"]);

  return React.createElement("div", null, React.createElement("div", Object.assign({
    className: 'object-input-decoration'
  }, props), label !== undefined ? React.createElement("div", {
    className: 'object-input-label'
  }, label, (required !== null && required !== void 0 ? required : false) ? React.createElement(Error$1, null, " *") : null) : null, React.createElement("div", null, children)), helperText !== undefined || errors !== undefined && errors !== null ? React.createElement(HelperText, null, helperText, errors !== undefined && errors !== null ? React.createElement(Box, null, React.createElement(Error$1, null, errors.join())) : null) : null);
};
var ListInputCreateBox = function ListInputCreateBox(props) {
  return React.createElement("div", Object.assign({
    className: 'list-input-create-box'
  }, props));
};
var Flex = function Flex(_ref7) {
  var _ref7$className = _ref7.className,
      className = _ref7$className === void 0 ? '' : _ref7$className,
      props = _objectWithoutPropertiesLoose(_ref7, ["className"]);

  return React.createElement("div", Object.assign({
    className: "flex " + className
  }, props));
};
var Box = function Box(_ref8) {
  var _ref8$className = _ref8.className,
      className = _ref8$className === void 0 ? '' : _ref8$className,
      props = _objectWithoutPropertiesLoose(_ref8, ["className"]);

  return React.createElement("div", Object.assign({
    className: "box " + className
  }, props));
};
var Button = function Button(_ref9) {
  var _ref9$className = _ref9.className,
      className = _ref9$className === void 0 ? '' : _ref9$className,
      props = _objectWithoutPropertiesLoose(_ref9, ["className"]);

  return React.createElement("button", Object.assign({
    className: "btn " + className
  }, props));
};
var Error$1 = function Error(props) {
  return React.createElement("small", Object.assign({
    style: {
      color: 'red'
    }
  }, props));
};

var DefaultBaseComponents = {
  __proto__: null,
  BaseInput: BaseInput,
  BaseSelect: BaseSelect,
  BaseCheckbox: BaseCheckbox,
  HelperText: HelperText,
  LabelText: LabelText,
  Label: Label,
  FieldWrapper: FieldWrapper,
  ListInputDecoration: ListInputDecoration,
  ObjectInputDecoration: ObjectInputDecoration,
  ListInputCreateBox: ListInputCreateBox,
  Flex: Flex,
  Box: Box,
  Button: Button,
  Error: Error$1,
  FieldDecoration: FieldDecoration
};

var BaseComponentsContext = createContext(DefaultBaseComponents);
BaseComponentsContext.displayName = 'BaseComponentsContext';
var useBaseComponents = function useBaseComponents() {
  return useContext(BaseComponentsContext);
};

var partitionObject = function partitionObject(object, keys) {
  var set = new Set(keys);
  return Object.keys(object).reduce(function (prev, key) {
    if (set.has(key)) {
      prev[0][key] = object[key];
    } else {
      prev[1][key] = object[key];
    }

    return prev;
  }, [{}, {}]);
};

var partitionDecorationProps = function partitionDecorationProps(props) {
  return partitionObject(props, ['label', 'helperText', 'errors', 'required']);
};

var TextInput = function TextInput(props) {
  var onChange = props.onChange,
      value = props.value,
      otherProps = _objectWithoutPropertiesLoose(props, ["helperText", "onChange", "value", "label", "defaultVal"]);

  var _useBaseComponents = useBaseComponents(),
      BaseInput = _useBaseComponents.BaseInput;

  var _partitionDecorationP = partitionDecorationProps(props),
      decorationProps = _partitionDecorationP[0];

  return React.createElement(FieldDecoration, Object.assign({}, decorationProps), React.createElement(BaseInput, Object.assign({}, otherProps, {
    onChange: onChange,
    value: value
  })));
};

var NumberInput = function NumberInput(_ref) {
  var onChange = _ref.onChange,
      value = _ref.value,
      defaultVal = _ref.defaultVal,
      props = _objectWithoutPropertiesLoose(_ref, ["onChange", "value", "defaultVal"]);

  var handleChange = function handleChange(value) {
    var str = '';

    if (typeof value === 'string') {
      str = value;
    } else if ('value' in value.target) {
      str = value.target.value;
    }

    if (str === '') {
      onChange === null || onChange === void 0 ? void 0 : onChange(null);
    } else {
      onChange === null || onChange === void 0 ? void 0 : onChange(Number.parseFloat(str));
    }
  };

  return React.createElement(TextInput, Object.assign({
    onChange: handleChange,
    type: 'number'
  }, props, {
    value: value === null || value === void 0 ? void 0 : value.toString(),
    defaultVal: defaultVal === null || defaultVal === void 0 ? void 0 : defaultVal.toString()
  }));
};

var digKey = function digKey(object, key) {
  if (typeof key === 'string') {
    return object[key];
  } else {
    if (key.length === 0) {
      return object;
    } else {
      var head = key[0],
          tail = key.slice(1);
      return digKey(object[head], tail);
    }
  }
};

var processOptions = function processOptions(options, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      valueKey = _ref.valueKey,
      labelKey = _ref.labelKey;

  if (Array.isArray(options)) {
    return options.map(function (option) {
      var value;
      var label = typeof option === 'string' ? option : JSON.stringify(option);

      if (typeof option === 'object') {
        if (valueKey !== undefined) {
          value = digKey(option, valueKey);
        } else if ('value' in option) {
          value = option.value;
        } else {
          value = option;
        }

        if (labelKey !== undefined) {
          var digged = digKey(option, labelKey);
          label = typeof digged === 'string' ? digged : JSON.stringify(digged);
        } else if ('label' in option) {
          var _digged = option.label;
          label = typeof _digged === 'string' ? _digged : JSON.stringify(_digged);
        } else if (typeof value === 'string' || typeof value === 'number') {
          label = value.toString();
        }

        return _extends({}, option, {
          value: value,
          label: label
        });
      } else {
        value = option;
        return {
          value: value,
          label: label
        };
      }
    });
  } else {
    return Object.entries(options).map(function (_ref2) {
      var label = _ref2[0],
          value = _ref2[1];
      return {
        value: value,
        label: label
      };
    });
  }
};
var useProcessOptionsMemo = function useProcessOptionsMemo(options, settings) {
  return useMemo(function () {
    return options !== undefined ? processOptions(options, settings) : [];
  }, [options]);
};

var Select = function Select(props) {
  var options = props.options,
      value = props.value,
      onChange = props.onChange,
      valueKey = props.valueKey,
      labelKey = props.labelKey,
      otherProps = _objectWithoutPropertiesLoose(props, ["helperText", "label", "options", "value", "onChange", "valueKey", "labelKey", "defaultVal"]);

  var valueLabel = useProcessOptionsMemo(options, {
    labelKey: labelKey,
    valueKey: valueKey
  });

  var _useBaseComponents = useBaseComponents(),
      BaseSelect = _useBaseComponents.BaseSelect;

  var _partitionDecorationP = partitionDecorationProps(props),
      decorationProps = _partitionDecorationP[0];

  return React.createElement(FieldDecoration, Object.assign({}, decorationProps), React.createElement(BaseSelect, Object.assign({
    options: valueLabel,
    value: value,
    onChange: onChange
  }, otherProps)));
};

var useProcessBool = function useProcessBool(value, onChange, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      trueValue = _ref.trueValue,
      falseValue = _ref.falseValue;

  var flag = typeof value === 'boolean' ? value : trueValue !== undefined && value === trueValue;

  var handleChange = function handleChange() {
    var newValue = !flag;

    if (newValue) {
      if (trueValue !== undefined) {
        onChange === null || onChange === void 0 ? void 0 : onChange(trueValue);
      } else {
        onChange === null || onChange === void 0 ? void 0 : onChange(true);
      }
    } else {
      onChange === null || onChange === void 0 ? void 0 : onChange(falseValue);
    }
  };

  return [flag, handleChange];
};

var Checkbox = function Checkbox(props) {
  var onChange = props.onChange,
      value = props.value,
      trueValue = props.trueValue,
      falseValue = props.falseValue,
      otherProps = _objectWithoutPropertiesLoose(props, ["helperText", "onChange", "value", "label", "defaultVal", "trueValue", "falseValue"]);

  var _useProcessBool = useProcessBool(value, onChange, {
    trueValue: trueValue,
    falseValue: falseValue
  }),
      flag = _useProcessBool[0],
      handleChange = _useProcessBool[1];

  var _useBaseComponents = useBaseComponents(),
      Label = _useBaseComponents.Label,
      FieldDecoration = _useBaseComponents.FieldDecoration,
      BaseCheckbox = _useBaseComponents.BaseCheckbox,
      Flex = _useBaseComponents.Flex,
      Box = _useBaseComponents.Box;

  var _partitionDecorationP = partitionDecorationProps(props),
      decorationProps = _partitionDecorationP[0];

  return React.createElement(Box, null, React.createElement(Label, null, React.createElement(Flex, {
    style: {
      alignItems: 'baseline'
    }
  }, React.createElement(Box, null, React.createElement(BaseCheckbox, Object.assign({
    onChange: handleChange,
    checked: flag
  }, otherProps))), React.createElement(FieldDecoration, Object.assign({}, decorationProps, {
    noLabel: true
  })))));
};

var isSet = function isSet(set) {
  if (typeof set === 'object' && set !== null) {
    return 'add' in set && 'clear' in set && 'delete' in set && 'entries' in set && 'forEach' in set && 'has' in set && 'keys' in set;
  } else {
    return false;
  }
};

var processMultiSelectValue = function processMultiSelectValue(value) {
  if (value === undefined) {
    return new Set([]);
  } else if (isSet(value)) {
    return value;
  }

  if (Array.isArray(value)) {
    return new Set(value);
  } else {
    return new Set(Object.entries(value).filter(function (_ref) {
      var flag = _ref[1];
      return flag;
    }).map(function (_ref2) {
      var value = _ref2[0];
      return value;
    }));
  }
};
var generateMultiSelectValue = function generateMultiSelectValue(set, output) {
  if (output === void 0) {
    output = 'array';
  }

  if (output === 'set') {
    return set;
  } else if (output === 'array') {
    return Array.from(set);
  } else {
    var ret = {};
    set.forEach(function (key) {
      if (typeof key === 'string') {
        ret[key] = true;
      } else {
        throw new Error('value of options of multiselect view must be of type string');
      }
    });
    return ret;
  }
};
var useProcessMultiSelectMemo = function useProcessMultiSelectMemo(onChange, value, output) {
  if (output === void 0) {
    output = 'array';
  }

  return useMemo(function () {
    var flags = processMultiSelectValue(value);

    var setFlag = function setFlag(value) {
      return function () {
        if (flags.has(value)) {
          flags["delete"](value);
        } else {
          flags.add(value);
        }

        onChange === null || onChange === void 0 ? void 0 : onChange(generateMultiSelectValue(flags, output));
      };
    };

    return [flags, setFlag];
  }, [onChange, value, output]);
};

var CheckboxGroup = function CheckboxGroup(props) {
  var onChange = props.onChange,
      value = props.value,
      options = props.options,
      valueKey = props.valueKey,
      labelKey = props.labelKey,
      output = props.output;
  var Checkbox = useFieldComponents().checkbox;
  var valueLabel = useProcessOptionsMemo(options, {
    labelKey: labelKey,
    valueKey: valueKey
  });

  var _useProcessMultiSelec = useProcessMultiSelectMemo(onChange, value, output),
      flags = _useProcessMultiSelec[0],
      setFlag = _useProcessMultiSelec[1];

  var _useBaseComponents = useBaseComponents(),
      Box = _useBaseComponents.Box;

  var _partitionDecorationP = partitionDecorationProps(props),
      decorationProps = _partitionDecorationP[0];

  return React.createElement(Box, null, React.createElement(FieldDecoration, Object.assign({}, decorationProps)), valueLabel.map(function (_ref) {
    var value = _ref.value,
        label = _ref.label,
        otherProps = _objectWithoutPropertiesLoose(_ref, ["value", "label"]);

    return React.createElement(Checkbox, Object.assign({
      key: label
    }, otherProps, {
      label: label,
      value: flags.has(value),
      onChange: setFlag(value)
    }));
  }));
};

var MissingAttributeError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(MissingAttributeError, _Error);

  function MissingAttributeError(attributes, fieldName, fieldType) {
    var _this;

    _this = _Error.call(this, MissingAttributeError.getMessage(attributes, fieldName, fieldType)) || this;
    _this.name = 'MissingAttributeError';
    return _this;
  }

  MissingAttributeError.getMessage = function getMessage(attributes, fieldName, fieldType) {
    var message = '';

    if (fieldName !== undefined) {
      message += "Field '" + fieldName + "'";
    } else {
      message += 'A field';
    }

    message += ' is missing the required attribute';

    if (typeof attributes === 'string') {
      message += " '" + attributes + "'";
    } else {
      message += "s '" + attributes.join('\', \'') + "'";
    }

    if (fieldType !== undefined) {
      message += " as a '" + fieldType + "' field";
    }

    message += '.';
    return message;
  };

  return MissingAttributeError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var generalizeValueCallback = function generalizeValueCallback(valueCallback) {
  return function (param) {
    if (typeof param === 'object') {
      if (param !== null && 'target' in param) {
        valueCallback(param.target.value);
      } else {
        valueCallback(param);
      }
    } else {
      valueCallback(param);
    }
  };
};
var generalizeOptionalValueCallback = function generalizeOptionalValueCallback(valueCallback) {
  if (valueCallback === undefined) return undefined;
  return generalizeValueCallback(valueCallback);
};

var UndefinedFieldTypeError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(UndefinedFieldTypeError, _Error);

  function UndefinedFieldTypeError(fieldType, fieldName) {
    var _this;

    _this = _Error.call(this, UndefinedFieldTypeError.getMessage(fieldType, fieldName)) || this;
    _this.name = 'UndefinedFieldTypeError';
    return _this;
  }

  UndefinedFieldTypeError.getMessage = function getMessage(fieldType, fieldName) {
    return (fieldName === undefined ? 'Some field' : "Field '" + fieldName + "'") + (" uses an undefined field type '" + fieldType + "',\n     please make sure you had register a FieldComponent for this type in ReformlProvider, \n     or specify another field type for this field.");
  };

  return UndefinedFieldTypeError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var getComponent = function getComponent(Components, field, fieldName) {
  if (typeof field === 'string') {
    var Component = Components[field];

    if (Component === undefined) {
      throw new UndefinedFieldTypeError(field, fieldName);
    }

    return Component;
  } else {
    if (field.type === undefined) {
      throw new MissingAttributeError('type', fieldName);
    }

    var _Component = Components[field.type];

    if (_Component === undefined) {
      throw new UndefinedFieldTypeError(field.type, fieldName);
    }

    return _Component;
  }
};

function mergeDefaultValue(fields, formValue) {
  var flag = false;
  Object.entries(_extends({}, fields)).forEach(function (_ref) {
    var fieldName = _ref[0],
        field = _ref[1];

    if (formValue[fieldName] === undefined) {
      if (field.defaultVal !== undefined) {
        flag = true;

        if (Array.isArray(field.defaultVal)) {
          formValue[fieldName] = Object.assign([], field.defaultVal);
        } else if (typeof field.defaultVal === 'object') {
          formValue[fieldName] = Object.assign({}, field.defaultVal);
        } else {
          formValue[fieldName] = field.defaultVal;
        }
      }
    }
  });
  return flag;
}

var Remove = function Remove() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, React.createElement("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z",
    fill: "#ffffff"
  }));
};

var DefaultInputComponent = function DefaultInputComponent(_ref) {
  var of = _ref.of,
      inlineDelete = _ref.inlineDelete,
      listName = _ref.listName,
      value = _ref.value,
      type = _ref.type,
      name = _ref.name,
      _ref$deletable = _ref.deletable,
      deletable = _ref$deletable === void 0 ? true : _ref$deletable,
      isCreating = _ref.isCreating,
      onChange = _ref.onChange,
      onDelete = _ref.onDelete,
      props = _objectWithoutPropertiesLoose(_ref, ["of", "inlineDelete", "listName", "value", "type", "name", "editable", "deletable", "isCreating", "onChange", "onDelete"]);

  if (type === undefined) {
    throw new MissingAttributeError('of.type', name === undefined ? listName : name);
  }

  var Components = useFieldComponents();

  var _useBaseComponents = useBaseComponents(),
      Box = _useBaseComponents.Box,
      Button = _useBaseComponents.Button;

  var Component = getComponent(Components, type, name);
  return React.createElement(Box, {
    className: isCreating ? 'list-input-create-box' : 'list-input-item-box'
  }, React.createElement(Box, {
    className: inlineDelete === true ? 'flex' : ''
  }, React.createElement(Box, {
    className: 'flex1'
  }, React.createElement(Component, Object.assign({}, props, typeof of === 'string' ? {} : of, {
    value: value,
    onChange: onChange !== undefined ? generalizeValueCallback(onChange) : undefined
  }))), React.createElement(Box, null, !isCreating && deletable ? React.createElement(Button, {
    className: 'btn-danger',
    onClick: onDelete
  }, React.createElement(Remove, null)) : null)));
};

var DefaultDecorationComponent = function DefaultDecorationComponent(props) {
  var _useBaseComponents2 = useBaseComponents(),
      ListInputDecoration = _useBaseComponents2.ListInputDecoration;

  return React.createElement(ListInputDecoration, Object.assign({}, props));
};

function ListInputBuilder(_temp) {
  var _ref2 = _temp === void 0 ? {} : _temp,
      _ref2$InputComponent = _ref2.InputComponent,
      InputComponent = _ref2$InputComponent === void 0 ? DefaultInputComponent : _ref2$InputComponent,
      _ref2$DecorationCompo = _ref2.DecorationComponent,
      DecorationComponent = _ref2$DecorationCompo === void 0 ? DefaultDecorationComponent : _ref2$DecorationCompo,
      defaultProps = _ref2.defaultProps;

  var ListInput = function ListInput(props) {
    var onChange = props.onChange,
        _props$deletable = props.deletable,
        deletable = _props$deletable === void 0 ? true : _props$deletable,
        _props$creatable = props.creatable,
        creatable = _props$creatable === void 0 ? true : _props$creatable,
        _props$editable = props.editable,
        editable = _props$editable === void 0 ? true : _props$editable,
        of = props.of,
        _props$value = props.value,
        value = _props$value === void 0 ? [] : _props$value,
        name = props.name,
        defaultNewVal = props.defaultNewVal,
        createLabel = props.createLabel,
        placeholder = props.placeholder,
        inlineDelete = props.inlineDelete,
        errors = props.errors;
    var subErrors = value.map(function () {
      return undefined;
    });
    var rootErrors;

    if (errors !== undefined && errors !== null) {
      var nestedErrors = errors === null || errors === void 0 ? void 0 : errors.filter(function (e) {
        return Array.isArray(e);
      });

      if (nestedErrors.length > 0 && Array.isArray(nestedErrors[0]) && nestedErrors[0] !== undefined) {
        subErrors = nestedErrors[0];
      }

      rootErrors = errors === null || errors === void 0 ? void 0 : errors.filter(function (e) {
        return typeof e === 'string';
      });
    }

    var handleEdit = function handleEdit(index) {
      return function (v) {
        if (value !== undefined && editable) {
          value[index] = v;
          onChange === null || onChange === void 0 ? void 0 : onChange([].concat(value));
        }
      };
    };

    var handleDelete = function handleDelete(index) {
      return function () {
        if (value !== undefined && deletable) {
          onChange === null || onChange === void 0 ? void 0 : onChange(value.filter(function (_, k) {
            return k !== index;
          }));
        }
      };
    };

    var handleCreate = function handleCreate(v) {
      if (creatable) {
        if (value === undefined) {
          onChange === null || onChange === void 0 ? void 0 : onChange([v]);
        } else {
          value.push(v);
          onChange === null || onChange === void 0 ? void 0 : onChange(value);
        }
      }
    };

    var _partitionDecorationP = partitionDecorationProps(props),
        decorationProps = _partitionDecorationP[0];

    return React.createElement(DecorationComponent, Object.assign({}, decorationProps, {
      errors: rootErrors
    }), [].concat(value, [defaultNewVal]).map(function (v, index) {
      return index !== value.length ? React.createElement(InputComponent, Object.assign({
        key: index,
        name: name,
        type: typeof of === 'string' ? of : undefined
      }, typeof of !== 'string' ? of : {}, {
        of: of,
        value: v,
        onChange: generalizeValueCallback(handleEdit(index)),
        disabled: !editable,
        deletable: deletable,
        editable: editable,
        onDelete: handleDelete(index),
        isCreating: false,
        inlineDelete: inlineDelete,
        errors: subErrors[index]
      })) : creatable ? React.createElement(InputComponent, Object.assign({
        key: index,
        name: name,
        type: typeof of === 'string' ? of : undefined
      }, typeof of !== 'string' ? of : {}, {
        of: of,
        label: createLabel,
        placeholder: placeholder,
        value: v,
        onChange: generalizeValueCallback(handleCreate),
        isCreating: true,
        inlineDelete: inlineDelete
      })) : null;
    }));
  };

  ListInput.defaultProps = defaultProps;
  return ListInput;
}

var ListInput = ListInputBuilder();
ListInput.propTypes = _extends({}, FieldPropTypes);

var ObjectInput = function ObjectInput(props) {
  var onChange = props.onChange,
      value = props.value,
      fields = props.fields,
      defaultVal = props.defaultVal,
      name = props.name,
      type = props.type;

  if (onChange === undefined) {
    throw new Error('onChange is required');
  }

  if (fields === undefined) {
    throw new MissingAttributeError('fields', name, type);
  }

  var _useBaseComponents = useBaseComponents(),
      ObjectInputDecoration = _useBaseComponents.ObjectInputDecoration,
      Box = _useBaseComponents.Box;

  var _partitionDecorationP = partitionDecorationProps(props),
      decorationProps = _partitionDecorationP[0];

  return React.createElement(ObjectInputDecoration, Object.assign({}, decorationProps), React.createElement(Box, {
    className: 'object-item-box'
  }, React.createElement(BaseForm, {
    onChange: generalizeValueCallback(onChange),
    fields: fields,
    value: value === undefined ? defaultVal === undefined ? {} : defaultVal : value
  })));
};

var DefaultFieldComponents = {
  text: TextInput,
  number: NumberInput,
  select: Select,
  checkbox: Checkbox,
  checkbox_group: CheckboxGroup,
  list: ListInput,
  object: ObjectInput
};

var FieldComponentsContext = createContext(DefaultFieldComponents);
FieldComponentsContext.displayName = 'FieldComponentsContext';
var useFieldComponents = function useFieldComponents() {
  return useContext(FieldComponentsContext);
};

var defaultValidators = {
  pattern: function pattern(value, property) {
    var regex = typeof property === 'string' ? new RegExp("^" + property + "$") : property;
    return typeof value === 'string' && regex.test(value);
  },
  min: function min(value, property) {
    return (typeof value === 'number' || value instanceof Date) && value >= property;
  },
  max: function max(value, property) {
    return (typeof value === 'number' || value instanceof Date) && value <= property;
  },
  step: function step(value, property, min) {
    if (!(typeof value === 'number' || value instanceof Date)) {
      return false;
    }

    var mod = (value - min) % property;
    return mod === 0 || mod / property < 0.00001 || (property - mod) / property < 0.00001;
  },
  minLength: function minLength(value, property) {
    return (typeof value === 'string' || Array.isArray(value)) && value.length >= property;
  },
  maxLength: function maxLength(value, property) {
    return (typeof value === 'string' || Array.isArray(value)) && value.length <= property;
  }
};

var ValidatorDictionaryContext = createContext(defaultValidators);
ValidatorDictionaryContext.displayName = 'ValidatorDictionaryContext';
var useValidatorDictionary = function useValidatorDictionary() {
  return useContext(ValidatorDictionaryContext);
};

var isValidatorSettings = function isValidatorSettings(what) {
  return typeof what === 'object' && what !== null && Object.keys(what).length === 1;
};

var WrongValidatorSettingError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(WrongValidatorSettingError, _Error);

  function WrongValidatorSettingError() {
    var _this;

    _this = _Error.apply(this, arguments) || this;
    _this.name = 'WrongValidatorSettingError';
    _this.message = 'Wrong Validator Setting';
    return _this;
  }

  return WrongValidatorSettingError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var fieldValidatorToNameFunctionAndParams = function fieldValidatorToNameFunctionAndParams(fieldValidator, validatorDictionary) {
  var ruleName = '';
  var validate;
  var params = [];

  if (typeof fieldValidator === 'string') {
    validate = validatorDictionary[fieldValidator];
    ruleName = fieldValidator;
  } else if (isValidatorSettings(fieldValidator)) {
    var _Object$entries$ = Object.entries(fieldValidator)[0],
        validatorName = _Object$entries$[0],
        validatorParams = _Object$entries$[1];
    ruleName = validatorName;

    if (typeof validatorParams === 'function') {
      validate = validatorParams;
    } else if (Array.isArray(validatorParams)) {
      validate = validatorDictionary[validatorName];
      params = validatorParams;
    } else {
      validate = validatorDictionary[validatorName];
      params.push(validatorParams);
    }
  } else {
    throw new WrongValidatorSettingError();
  }

  return [ruleName, validate, params];
};
var validateField = function validateField(value, fieldValidators, validatorDictionary, validateErrorFormatter) {
  var result = fieldValidators.map(function (validator) {
    var _fieldValidatorToName = fieldValidatorToNameFunctionAndParams(validator, validatorDictionary),
        ruleName = _fieldValidatorToName[0],
        validate = _fieldValidatorToName[1],
        params = _fieldValidatorToName[2];

    if (validate.apply(void 0, [value].concat(params))) {
      return undefined;
    } else {
      var _validateErrorFormatt;

      return (_validateErrorFormatt = validateErrorFormatter === null || validateErrorFormatter === void 0 ? void 0 : validateErrorFormatter(value, ruleName, params)) !== null && _validateErrorFormatt !== void 0 ? _validateErrorFormatt : ruleName;
    }
  }).filter(function (v) {
    return typeof v === 'string';
  });
  return result.length > 0 ? result : undefined;
};

var isDefined = function isDefined(value) {
  return value !== '' && value !== undefined && (Array.isArray(value) && value.length > 0 || typeof value === 'object' && value !== null && Object.values(value).filter(isDefined).length > 0 || typeof value !== 'object');
};

var validateForm = function validateForm(formValue, fields, validatorDictionary, validateErrorFormatter) {
  var errors = {};
  Object.entries(fields).forEach(function (_ref) {
    var fieldName = _ref[0],
        field = _ref[1];

    if (fieldName in formValue && isDefined(formValue[fieldName])) {
      var value = formValue[fieldName];
      var fieldErr = [];

      if ('fields' in field) {
        if (isFormValue(value)) {
          var subErr = validateForm(value, field.fields, validatorDictionary, validateErrorFormatter);

          if (subErr !== undefined) {
            fieldErr.push(subErr);
          }
        }
      }

      if (Array.isArray(value) && isListField(field)) {
        if (field.of !== undefined && typeof field.of !== 'string' && field.of.validate !== undefined) {
          var y = field.of.validate;

          var _subErr = value.map(function (subValue) {
            return validateField(subValue, y, validatorDictionary, validateErrorFormatter);
          });

          if (_subErr.filter(function (v) {
            return v !== undefined;
          }).length > 0) {
            fieldErr.push(_subErr);
          }
        }
      }

      if (field.validate !== undefined) {
        var generalErr = validateField(value, field.validate, validatorDictionary, validateErrorFormatter);

        if (generalErr !== undefined) {
          fieldErr.push.apply(fieldErr, generalErr);
        }
      }

      if (fieldErr.length > 0) {
        errors[fieldName] = fieldErr;
      }
    } else {
      var _field$required;

      if ((_field$required = field.required) !== null && _field$required !== void 0 ? _field$required : false) {
        errors[fieldName] = ['required'];
      }
    }
  });
  return Object.keys(errors).length === 0 ? undefined : errors;
};

var constraintToValidator = {
  pattern: function pattern(property) {
    return {
      pattern: [property]
    };
  },
  min: function min(property) {
    return {
      min: [property]
    };
  },
  max: function max(property) {
    return {
      max: [property]
    };
  },
  step: function step(property, field) {
    if (!('min' in field)) {
      throw new MissingAttributeError('min');
    }

    return {
      step: [property, field.min]
    };
  },
  minLength: function minLength(property) {
    return {
      minLength: [property]
    };
  },
  maxLength: function maxLength(property) {
    return {
      maxLength: [property]
    };
  }
};

var processFieldConstraints = function processFieldConstraints(field) {
  Object.keys(field).forEach(function (key) {
    if (key in constraintToValidator) {
      if (field.validate === undefined) {
        field.validate = [];
      }

      var validator = constraintToValidator[key](field[key], field);
      field.validate.push(validator);
    }
  });
  return field;
};

var fieldsConstraintsToValidate = function fieldsConstraintsToValidate(fields) {
  var ret = {};
  Object.entries(fields).forEach(function (_ref) {
    var fieldName = _ref[0],
        field = _ref[1];
    ret[fieldName] = processFieldConstraints(Object.assign({}, field));

    if (isObjectField(field)) {
      if (field.fields !== undefined) {
        ret[fieldName].fields = fieldsConstraintsToValidate(field.fields);
      }
    }

    if (isListField(field)) {
      if (field.of !== undefined && typeof field.of !== 'string') {
        ret[fieldName].of = processFieldConstraints(Object.assign({}, field.of));
      }
    }
  });
  return ret;
};

var defaultValidateErrorFormatter = function defaultValidateErrorFormatter(_, ruleName, params) {
  return ruleName + (params.length === 0 ? '' : ':' + params.join(','));
};

var ValidateErrorFormatterContext = createContext(defaultValidateErrorFormatter);
ValidateErrorFormatterContext.displayName = 'ValidateErrorFormatterContext';
var useValidateErrorFormatter = function useValidateErrorFormatter() {
  return useContext(ValidateErrorFormatterContext);
};

var Comparison;

(function (Comparison) {
  Comparison["EQ"] = "$eq";
  Comparison["NEQ"] = "$neq";
  Comparison["GT"] = "$gt";
  Comparison["GTE"] = "$gte";
  Comparison["LT"] = "$lt";
  Comparison["LTE"] = "$lte";
  Comparison["IN"] = "$in";
})(Comparison || (Comparison = {}));

var conditionFunctionBuilder = function conditionFunctionBuilder(condition) {
  return function (formValue) {
    return Object.entries(condition).map(function (_ref) {
      var fieldName = _ref[0],
          compare = _ref[1];
      var lhs = get(formValue, fieldName);
      return Object.keys(compare).map(function (operator) {
        switch (operator) {
          case Comparison.EQ:
            return lhs === compare[operator];

          case Comparison.NEQ:
            return lhs !== compare[operator];

          case Comparison.GT:
            {
              var rhs = compare[operator];

              if (typeof lhs === 'number' && rhs !== undefined) {
                return lhs > rhs;
              } else {
                return false;
              }
            }

          case Comparison.GTE:
            {
              var _rhs = compare[operator];

              if (typeof lhs === 'number' && _rhs !== undefined) {
                return lhs >= _rhs;
              } else {
                return false;
              }
            }

          case Comparison.LTE:
            {
              var _rhs2 = compare[operator];

              if (typeof lhs === 'number' && _rhs2 !== undefined) {
                return lhs <= _rhs2;
              } else {
                return false;
              }
            }

          case Comparison.LT:
            {
              var _rhs3 = compare[operator];

              if (typeof lhs === 'number' && _rhs3 !== undefined) {
                return lhs < _rhs3;
              } else {
                return false;
              }
            }

          case Comparison.IN:
            {
              var _rhs4 = compare[operator];

              if (Array.isArray(_rhs4)) {
                return _rhs4.includes(lhs);
              } else {
                return false;
              }
            }

          default:
            return false;
        }
      }).reduce(function (a, b) {
        return a && b;
      }, true);
    }).reduce(function (a, b) {
      return a && b;
    }, true);
  };
};

var getIfFilter = function getIfFilter(formValue, ifFieldKey) {
  return function (_ref) {
    var fieldDef = _ref[1];
    var conditionChecker = fieldDef[ifFieldKey];

    if (conditionChecker === undefined) {
      return true;
    } else if (typeof conditionChecker === 'string') {
      return formValue[conditionChecker] === true;
    } else if (typeof conditionChecker === 'function') {
      return conditionChecker(formValue);
    } else {
      return conditionFunctionBuilder(conditionChecker)(formValue);
    }
  };
};

var BaseFormPropTypes = {
  onChange: propTypes.func,
  fields: propTypes.object,
  value: propTypes.object
};
function BaseForm(_ref) {
  var onChange = _ref.onChange,
      propFields = _ref.fields,
      value = _ref.value;
  var Components = useFieldComponents();
  var appliedDefault = useRef(false);
  var flag = false;

  if (!appliedDefault.current) {
    flag = mergeDefaultValue(propFields, value);
    appliedDefault.current = true;
  }

  var processedPropFields = useMemo(function () {
    return fieldsConstraintsToValidate(propFields);
  }, [propFields]);

  var _useState = useState(processedPropFields),
      fields = _useState[0],
      setFields = _useState[1];

  var _useState2 = useState(undefined),
      validateErrors = _useState2[0],
      setValidateErrors = _useState2[1];

  var validatorDictionary = useValidatorDictionary();
  var validateErrorFormatter = useValidateErrorFormatter();

  var getValidate = function getValidate(value) {
    return function () {
      var error = validateForm(value, fields, validatorDictionary, validateErrorFormatter);
      setValidateErrors(error);
      return error;
    };
  };

  var reduceFields = function reduceFields(reducer) {
    return setFields(reducer(fields));
  };

  var changeHandler = function changeHandler(value) {
    onChange(value, {
      reduceFields: reduceFields,
      validate: getValidate(value)
    });
  };

  useEffect(function () {
    if (flag) {
      changeHandler(_extends({}, value));
    }
  }, [flag]);

  var handleChange = function handleChange(fieldName, fieldValue) {
    var _extends2;

    changeHandler(_extends({}, value, (_extends2 = {}, _extends2[fieldName] = fieldValue, _extends2)));
  };

  var _useBaseComponents = useBaseComponents(),
      FieldWrapper = _useBaseComponents.FieldWrapper;

  return React.createElement(React.Fragment, null, Object.entries(fields).filter(function (_ref2) {
    var field = _ref2[1];
    return getIfFilter(value, 'showIf')([undefined, field]);
  }).map(function (_ref3) {
    var fieldName = _ref3[0],
        _ref3$ = _ref3[1],
        field = _objectWithoutPropertiesLoose(_ref3$, ["showIf"]);

    var Component = getComponent(Components, field, fieldName);
    var errors = validateErrors === null || validateErrors === void 0 ? void 0 : validateErrors[fieldName];
    var changeHandler = generalizeValueCallback(function (value) {
      return handleChange(fieldName, value);
    });
    return React.createElement(FieldWrapper, {
      key: fieldName
    }, React.createElement(Component, Object.assign({}, field, {
      value: value[fieldName],
      name: fieldName,
      onChange: changeHandler,
      errors: errors
    })));
  }));
}

var ReformlProvider = function ReformlProvider(_ref) {
  var validateErrorFormatter = _ref.validateErrorFormatter,
      validatorDictionary = _ref.validatorDictionary,
      fieldComponents = _ref.fieldComponents,
      baseComponents = _ref.baseComponents,
      children = _ref.children;
  return React.createElement(ValidateErrorFormatterContext.Provider, {
    value: validateErrorFormatter !== null && validateErrorFormatter !== void 0 ? validateErrorFormatter : defaultValidateErrorFormatter
  }, React.createElement(ValidatorDictionaryContext.Provider, {
    value: _extends({}, defaultValidators, validatorDictionary)
  }, React.createElement(BaseComponentsContext.Provider, {
    value: _extends({}, DefaultBaseComponents, baseComponents)
  }, React.createElement(FieldComponentsContext.Provider, {
    value: _extends({}, DefaultFieldComponents, fieldComponents)
  }, children))));
};

export { BaseBoolPropTypes, BaseForm, BaseFormPropTypes, BaseSelectPropTypes, BasicFieldPropTypes, DefaultFieldComponents, DigKeyPropType, FieldComponentsContext, FieldPropTypes, ListFieldPropTypes, MissingAttributeError, MultiSelectFieldPropTypes, NumberInput, ObjectFieldPropTypes, OptionsFieldPropTypes, ReformlProvider, Select, TextInput, UndefinedFieldTypeError, digKey, generalizeOptionalValueCallback, generalizeValueCallback, generateMultiSelectValue, getComponent, isFormValue, isListField, isObjectField, isSet, mergeDefaultValue, processMultiSelectValue, processOptions, useFieldComponents, useProcessBool, useProcessMultiSelectMemo, useProcessOptionsMemo };
//# sourceMappingURL=index.modern.js.map
